import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CancelIcon from "@material-ui/icons/Cancel";
import { qsParse } from "common";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import Button from "../buttons/Button";
const useStyles = makeStyles((theme) => ({
    root: ({ fullPage }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: fullPage ? theme.spacing(4) : "inherit",
        "& > *": {
            marginBottom: theme.spacing(2),
        },
    }),
    cancelIcon: {
        fontSize: 60,
    },
    errorContainer: {
        textAlign: "center",
        marginBottom: theme.spacing(5),
    },
}));
export default function AuthErrorPage({ fullPage = false }) {
    const classes = useStyles({ fullPage });
    const location = useLocation();
    const { logout } = useAuth0();
    // Get the error message from the URL.
    const parsedLocation = qsParse(location.search);
    const errorMessage = (parsedLocation === null || parsedLocation === void 0 ? void 0 : parsedLocation.message) || "";
    return (React.createElement("div", { className: classes.root },
        React.createElement(CancelIcon, { className: classes.cancelIcon }),
        React.createElement("div", { className: classes.errorContainer },
            React.createElement(Typography, { variant: "h3", gutterBottom: true },
                React.createElement(FormattedMessage, { id: "ui-kit-error.loginError" })),
            errorMessage && React.createElement(Typography, { variant: "h4" }, errorMessage)),
        React.createElement(Button, { onClick: logout },
            React.createElement(FormattedMessage, { id: "ui-kit-tryAgain" }))));
}
AuthErrorPage.defaultProps = {
    fullPage: false,
};
//# sourceMappingURL=index.js.map